export default ({ model, fileName, fileSize, fileUrl, packageData }) => ({
    files: [],
    detail: [],
    currentFile: 0,
    model,
    packageData,
    init(){
        window.addEventListener(model + '::check-files', ({detail}) => {
            if(_.get(detail, 'name')) {
                this.setFiles([{
                    name: detail.name,
                    size: detail.size,
                    url: detail.url,
                }]);

                return;
            }

            this.clear();
        });

        this.$el.addEventListener('refresh-price', ({detail}) => {
            this.packageData.price = detail[0];
        });

        this.addInputEvents();
        this.checkFiles();
    },

    checkFiles() {
        const files = this.$wire.get(this.model);

        if(Array.isArray(files)){
            this.files = files.map((file) => {
                return {
                    name: file.name,
                    size: file.size,
                    url: file.url
                };
            });

            return;
        }

        if (!fileName) {
            return;
        }

        this.setFiles([{
            name: fileName,
            size: fileSize,
            url: fileUrl,
        }]);
    },

    removeFile(index) {
        this.$wire.set(this.model, null);
        this.files[index].deleted = true;

        this.clear();

        this.$dispatch('upload-preview-image', [false]);
    },

    async setFiles(files) {
        this.files = await Array.from(files);
        return this;
    },

    isEmpty(){
        return !this.files.length || this.files.every((file) => file.hasOwnProperty('deleted'));
    },

    async onChange({ target }) {
        if(target.files.length === 0){
            return;
        }

        await this.setFiles(target.files);
        this.getDetail(this.currentFile);
    },

    addInputEvents() {
      const input = this.$el.parentNode.querySelector('input[type="file"]');

      input.addEventListener('change', (event) => this.onChange(event));
      input.addEventListener('drop', ({target}) => target.classList.remove('active'));
      input.addEventListener('dragover', ({target}) => target.classList.add('active'));
      input.addEventListener('dragleave', ({target}) => target.classList.add('active'));
    },

    getDetail(index) {
        this.detail[index] = _.get(this.detail, index, {
            progress: 0,
            message: null
        });

        this.$dispatch('upload-preview-image', [true]);

        return this.detail[index];
    },

    getLastFile(){
        return this.files.length - 1;
    },

    dispatchFinishedEvents(){
        this.$dispatch('uploads-finished');
    },

    clear(){
        this.$nextTick(() => {
            this.files = [];
            this.detail = [];

            if(this.hasOwnProperty('$wire')) {
                this.$wire.set(this.model, null);
            }

            document.getElementById('input::'+this.model).value = '';
        });
    },
});
